import React, { Fragment } from 'react';
import {
  Card,
  Grid,
  Icon,
  Divider,
  Button
} from 'semantic-ui-react';
import Content from './Content';
import ClaimPreview from './ClaimPreview';
import ClaimEmailMessagesSidebar from './ClaimEmailMessagesSidebar';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import CloseClaimModal from './modals/CloseClaimModal';
import Priority from './TasksListComponents/Priority'

class Task extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isClaimVisible: false,
      isSideBarHidden: true
    };
    this.state = {...this.state, ...props.location.state};
  }


  componentDidUpdate = (prevProps, prevState) => {
    if(prevState.isClaimVisible !== this.state.isClaimVisible && this.state.isClaimVisible) {
      this.refs.claim.scrollIntoView({behavior: 'smooth'});
    }
  }

  handleToggleClick = () => {
    this.setState({
      isClaimVisible: !this.state.isClaimVisible
    })
  }

  handleToggleSidebar = () => {
    this.setState({
      isSideBarHidden: !this.state.isSideBarHidden
    })
  }

  handleCloseClaim = () => {
    const {onCloseClaim} = this.props
    if (onCloseClaim) {
      return onCloseClaim
    } else {
      this.setState({closeModalOpen: true})
    }
  }

  render = () => {
    const {
      id,
      date,
      icon,
      title,
      children,
      loading,
      priority
    } = this.props;
    return (
      <Content
        MenuItems={ClaimEmailMessagesSidebar}
        loading={this.state.loading || loading}
        isSideBarHidden={this.state.isSideBarHidden}
      >
        <Card fluid>
          <Card.Content>
            <Card.Header>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={14}>
                    <Icon name={icon} size="large"/>
                    {id}: {title}
                    <div style={{'marginLeft': '10px', 'display': 'inline-block'}}>
                      <Priority priority={priority}/>
                    </div>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={2}>
                    {this.renderSideBarToggle()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Header>
            <Card.Meta>
              {moment(date).calendar()}
            </Card.Meta>
            <Divider />
            {children}
          </Card.Content>
          <Card.Content extra textAlign="left">
            { !this.props.hideClaim && this.renderClaimSection() }
          </Card.Content>
        </Card>
      </Content>
    )
  }


  renderSideBarToggle = () => {
    if(!this.props.claimId){
      return null
    }
    const icon = this.state.isSideBarHidden ? 'unordered list' : 'angle double right'
    return <Icon name={icon} size="large" onClick={this.handleToggleSidebar}/>
  }

  renderClaimSection() {
    const { hideCloseClaimBtn, onClaimClosed } = this.props
    if(this.props.claimId === undefined){
      return null
    }
    return (
      <Fragment>
        {!hideCloseClaimBtn &&
        <Button
          floated="right"
          size="mini"
          onClick={this.handleCloseClaim.bind(this)}>Close Claim
        </Button>}
        {this.state.closeModalOpen && <CloseClaimModal
          claimId={this.props.claimId}
          open={this.state.closeModalOpen}
          dimmer={true}
          hideModal={() => this.setState({closeModalOpen: false})}
          onClaimClosed={onClaimClosed}
        />}
        { this.renderClaimToggle() }
        { this.renderClaim() }
      </Fragment>
    )
  }


  renderClaimToggle = () => {
    if(!this.state.isClaimVisible) {
      return (
        <Button size="mini" onClick={this.handleToggleClick}>
          Show claim information
        </Button>
      )
    } else {
      return (
        <Button size="mini" onClick={this.handleToggleClick} style={{'marginTop': '10px'}}>
          Hide claim information
        </Button>
      )
    }
  }

  renderClaim = () => {
    if(this.state.isClaimVisible) {
      return (
        <Fragment>
          <Divider hidden/>
            <div ref="claim"/>
            <Card fluid >
              <ClaimPreview
                claimId={this.props.claimId}
              />
            </Card>
        </Fragment>
      )
    }
  }
}

export default withRouter(Task);



// WEBPACK FOOTER //
// ./src/component/TaskContainer.js